import { Slide } from '@features/powerpoint';
import { DEFAULT_SLIDE_MASTER } from '../../../slides/slide-master';
import { texts } from './visit-overview/texts';
import { Lci3Report } from '@components/Dashboard/dashboardSlice/schemas/lci3Reports';
import { shapes } from './visit-overview/shapes';
import { images } from './visit-overview/images';
import { ImageWithMetadata } from '@features/powerpoint';
import { ValueInput } from '@utils/formattersV2';

export type VisitOverviewSlideOptions = {
  objectives: string[];
  visitMetrics: Lci3Report['visitMetrics'];
  brandLogo: ImageWithMetadata | null;
  costPerIncrementalVisit: ValueInput;
};

export const visitOverviewSlide = (
  options: VisitOverviewSlideOptions
): Slide => ({
  slideMaster: DEFAULT_SLIDE_MASTER,
  texts: texts(options),
  shapes,
  images: images(options.brandLogo),
});
